import { Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useTranslation } from "react-i18next";

function TableColumnForPrint({ inputArray, setSeletedRow, handleOpen, indexOffset }) {
  const { t } = useTranslation();
  return (
    <Table sx={{ maxWidth: 680, marginTop: "2rem" }} aria-label="simple table">
      <TableHead style={{ backgroundColor: "#f5f5f5" }}>
        <TableRow>
          <TableCell style={{ padding: 6 }}>
            <Typography fontSize={"18px"} fontWeight="bold">
            مقدار
            </Typography>
          </TableCell>

          <TableCell style={{ padding: 6 }} align="center">
            <Typography fontSize={"18px"} fontWeight="bold" paddingLeft="2px">
            مصنوعات کا نام 
            </Typography>
          </TableCell>
          <TableCell style={{ padding: 6 }}>
            <Typography fontSize={"18px"} fontWeight="bold">
            شمار
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {inputArray.map((row, index) => {
          return (
            <TableRow
              key={index}
              style={{
                fontSize: "17px",
                fontWeight: "bold",

              }}
              onClick={() => {
                setSeletedRow(row);
                handleOpen();
              }}
            >
              <TableCell align="center"
                style={{ fontSize: 15, padding: '15px 2px', borderLeft: '1px solid #f5f5f5' }}
              >
                {row.quantity}{" "}
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "18px",
                  // fontWeight: "bold",
                  // fontFamily: 'NotoNastaliqUrdu',
                  padding: '15px 2px',

                }}
              >
                {row.name_urdu }
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "15px",
                  width: 22,
                  // backgroundColor: '#f5f5f5',
                  padding: '15px 2px',
                  borderRight: '1px solid #f5f5f5'
                }}
              >
                {"(" + (index + 1 + indexOffset) + ")"}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
export default TableColumnForPrint;